export interface CatalogDork {
  id: string;
  query: string;
  title: string;
  description: string;
  category: 'sensitive-directories' | 'sensitive-files' | 'servers' | 'error-messages' | 'login-pages' | 'network-devices' | 'databases' | 'file-discovery' | 'osint' | 'vulnerabilities';
  tags: string[];
  popularity: number; // 1-100 rating based on usage
  dateAdded: string;
  source?: string;
}

export const popularDorks: CatalogDork[] = [
  // Sensitive Directories
  {
    id: "cat-1",
    query: 'intitle:"Index of" "parent directory"',
    title: "Open Directory Listings",
    description: "Find exposed directory listings with browsable file structures",
    category: "sensitive-directories",
    tags: ["directory", "files", "exposed", "listing"],
    popularity: 98,
    dateAdded: "2020-01-15",
    source: "GHDB"
  },
  {
    id: "cat-2",
    query: 'intitle:"index of" inurl:ftp',
    title: "FTP Directory Listings",
    description: "Discover open FTP servers with directory listings",
    category: "sensitive-directories",
    tags: ["ftp", "directory", "server"],
    popularity: 92,
    dateAdded: "2019-06-20",
    source: "GHDB"
  },
  {
    id: "cat-3",
    query: 'intitle:"index of" ".git"',
    title: "Exposed Git Repositories",
    description: "Find exposed .git folders that may contain source code",
    category: "sensitive-directories",
    tags: ["git", "source-code", "repository"],
    popularity: 95,
    dateAdded: "2021-03-10",
    source: "GHDB"
  },
  {
    id: "cat-4",
    query: 'intitle:"index of" "backup"',
    title: "Backup Directories",
    description: "Locate exposed backup folders and files",
    category: "sensitive-directories",
    tags: ["backup", "files", "sensitive"],
    popularity: 88,
    dateAdded: "2020-05-22"
  },
  {
    id: "cat-5",
    query: 'intitle:"index of" wp-content/uploads',
    title: "WordPress Uploads Directory",
    description: "Find exposed WordPress upload directories",
    category: "sensitive-directories",
    tags: ["wordpress", "uploads", "cms"],
    popularity: 85,
    dateAdded: "2020-08-14"
  },

  // Sensitive Files
  {
    id: "cat-6",
    query: 'filetype:env "DB_PASSWORD"',
    title: "Exposed .env Files",
    description: "Find environment files containing database credentials",
    category: "sensitive-files",
    tags: ["credentials", "database", "config", "env"],
    popularity: 97,
    dateAdded: "2021-01-05",
    source: "GHDB"
  },
  {
    id: "cat-7",
    query: 'filetype:sql "INSERT INTO" password',
    title: "SQL Dumps with Passwords",
    description: "Locate SQL database dumps containing password data",
    category: "sensitive-files",
    tags: ["sql", "database", "passwords", "dump"],
    popularity: 94,
    dateAdded: "2019-11-30",
    source: "GHDB"
  },
  {
    id: "cat-8",
    query: 'filetype:log username password',
    title: "Log Files with Credentials",
    description: "Find log files that accidentally contain login credentials",
    category: "sensitive-files",
    tags: ["logs", "credentials", "username", "password"],
    popularity: 91,
    dateAdded: "2020-02-18"
  },
  {
    id: "cat-9",
    query: 'filetype:conf inurl:web.config',
    title: "Web.config Files",
    description: "Discover exposed ASP.NET configuration files",
    category: "sensitive-files",
    tags: ["config", "asp.net", "iis", "windows"],
    popularity: 86,
    dateAdded: "2019-09-12"
  },
  {
    id: "cat-10",
    query: 'filetype:bak inurl:"htaccess"',
    title: "htaccess Backup Files",
    description: "Find backup copies of Apache htaccess configuration",
    category: "sensitive-files",
    tags: ["apache", "htaccess", "backup", "config"],
    popularity: 82,
    dateAdded: "2020-04-25"
  },
  {
    id: "cat-11",
    query: '"-----BEGIN RSA PRIVATE KEY-----" filetype:key',
    title: "Exposed Private Keys",
    description: "Find exposed RSA private key files",
    category: "sensitive-files",
    tags: ["rsa", "private-key", "ssl", "security"],
    popularity: 93,
    dateAdded: "2021-02-08",
    source: "GHDB"
  },
  {
    id: "cat-12",
    query: 'filetype:pem "PRIVATE KEY"',
    title: "PEM Private Keys",
    description: "Locate exposed PEM certificate private keys",
    category: "sensitive-files",
    tags: ["pem", "certificate", "private-key"],
    popularity: 89,
    dateAdded: "2020-07-19"
  },

  // Login Pages
  {
    id: "cat-13",
    query: 'inurl:"/admin/login" OR inurl:"/administrator/login"',
    title: "Admin Login Panels",
    description: "Find administrative login pages",
    category: "login-pages",
    tags: ["admin", "login", "panel", "authentication"],
    popularity: 96,
    dateAdded: "2019-03-28",
    source: "GHDB"
  },
  {
    id: "cat-14",
    query: 'intitle:"Login" inurl:"/wp-login.php"',
    title: "WordPress Login Pages",
    description: "Discover WordPress admin login pages",
    category: "login-pages",
    tags: ["wordpress", "login", "cms", "admin"],
    popularity: 90,
    dateAdded: "2020-01-10"
  },
  {
    id: "cat-15",
    query: 'inurl:"/phpmyadmin/index.php"',
    title: "phpMyAdmin Panels",
    description: "Find exposed phpMyAdmin database management interfaces",
    category: "login-pages",
    tags: ["phpmyadmin", "database", "mysql", "admin"],
    popularity: 94,
    dateAdded: "2019-07-05",
    source: "GHDB"
  },
  {
    id: "cat-16",
    query: 'intitle:"Dashboard" inurl:"/admin"',
    title: "Admin Dashboards",
    description: "Locate administrative dashboard interfaces",
    category: "login-pages",
    tags: ["dashboard", "admin", "panel"],
    popularity: 87,
    dateAdded: "2020-09-30"
  },

  // Error Messages
  {
    id: "cat-17",
    query: '"SQL syntax" "mysql" filetype:php',
    title: "MySQL Error Messages",
    description: "Find pages exposing MySQL SQL syntax errors",
    category: "error-messages",
    tags: ["sql", "mysql", "error", "php"],
    popularity: 91,
    dateAdded: "2019-05-15",
    source: "GHDB"
  },
  {
    id: "cat-18",
    query: '"Warning: mysql_" OR "Warning: mysqli_"',
    title: "PHP MySQL Warnings",
    description: "Discover PHP pages with MySQL connection warnings",
    category: "error-messages",
    tags: ["php", "mysql", "warning", "debug"],
    popularity: 88,
    dateAdded: "2020-03-22"
  },
  {
    id: "cat-19",
    query: '"ORA-" site:*.edu',
    title: "Oracle Database Errors",
    description: "Find Oracle database error messages on educational sites",
    category: "error-messages",
    tags: ["oracle", "database", "error", "edu"],
    popularity: 79,
    dateAdded: "2019-12-08"
  },
  {
    id: "cat-20",
    query: '"Fatal error: Uncaught exception"',
    title: "PHP Fatal Errors",
    description: "Locate PHP pages with uncaught exception errors",
    category: "error-messages",
    tags: ["php", "error", "exception", "debug"],
    popularity: 84,
    dateAdded: "2020-06-14"
  },

  // Network Devices
  {
    id: "cat-21",
    query: 'intitle:"RouterOS" inurl:"/winbox"',
    title: "MikroTik RouterOS",
    description: "Find MikroTik router administration interfaces",
    category: "network-devices",
    tags: ["mikrotik", "router", "network", "winbox"],
    popularity: 86,
    dateAdded: "2021-01-20",
    source: "GHDB"
  },
  {
    id: "cat-22",
    query: 'intitle:"Cisco" "ASDM"',
    title: "Cisco ASDM Interfaces",
    description: "Discover Cisco Adaptive Security Device Manager interfaces",
    category: "network-devices",
    tags: ["cisco", "firewall", "asdm", "network"],
    popularity: 83,
    dateAdded: "2020-02-28"
  },
  {
    id: "cat-23",
    query: 'intitle:"webcamXP 5"',
    title: "WebcamXP Cameras",
    description: "Find exposed WebcamXP surveillance cameras",
    category: "network-devices",
    tags: ["webcam", "camera", "surveillance", "iot"],
    popularity: 90,
    dateAdded: "2019-08-17",
    source: "GHDB"
  },
  {
    id: "cat-24",
    query: 'inurl:"/view/view.shtml" OR inurl:"ViewerFrame?Mode"',
    title: "IP Cameras",
    description: "Locate exposed IP camera streams",
    category: "network-devices",
    tags: ["camera", "ip-camera", "surveillance", "stream"],
    popularity: 92,
    dateAdded: "2020-04-05"
  },
  {
    id: "cat-25",
    query: 'intitle:"printer" "status" inurl:"/hp/device"',
    title: "HP Printer Status Pages",
    description: "Find HP printer administration and status pages",
    category: "network-devices",
    tags: ["printer", "hp", "network", "iot"],
    popularity: 78,
    dateAdded: "2019-10-22"
  },

  // Databases
  {
    id: "cat-26",
    query: 'inurl:":9200/_cat"',
    title: "Elasticsearch Clusters",
    description: "Find exposed Elasticsearch cluster endpoints",
    category: "databases",
    tags: ["elasticsearch", "database", "nosql", "api"],
    popularity: 93,
    dateAdded: "2021-02-14",
    source: "GHDB"
  },
  {
    id: "cat-27",
    query: 'inurl:":27017" "mongodb"',
    title: "MongoDB Instances",
    description: "Discover exposed MongoDB database instances",
    category: "databases",
    tags: ["mongodb", "database", "nosql"],
    popularity: 91,
    dateAdded: "2020-05-30"
  },
  {
    id: "cat-28",
    query: 'intitle:"Kibana" inurl:"/app/kibana"',
    title: "Kibana Dashboards",
    description: "Find exposed Kibana visualization dashboards",
    category: "databases",
    tags: ["kibana", "elasticsearch", "dashboard", "logs"],
    popularity: 88,
    dateAdded: "2020-08-20"
  },
  {
    id: "cat-29",
    query: 'inurl:":5984/_utils"',
    title: "CouchDB Futon Interface",
    description: "Locate exposed CouchDB administration interfaces",
    category: "databases",
    tags: ["couchdb", "database", "nosql", "admin"],
    popularity: 80,
    dateAdded: "2019-11-15"
  },

  // File Discovery
  {
    id: "cat-30",
    query: 'filetype:xlsx "confidential" OR "internal use only"',
    title: "Confidential Excel Files",
    description: "Find Excel spreadsheets marked as confidential",
    category: "file-discovery",
    tags: ["excel", "spreadsheet", "confidential", "internal"],
    popularity: 89,
    dateAdded: "2020-01-25",
    source: "GHDB"
  },
  {
    id: "cat-31",
    query: 'filetype:pdf "password" "username"',
    title: "PDFs with Credentials",
    description: "Discover PDF documents containing credential information",
    category: "file-discovery",
    tags: ["pdf", "credentials", "password", "document"],
    popularity: 86,
    dateAdded: "2020-06-08"
  },
  {
    id: "cat-32",
    query: 'filetype:docx "draft" "not for distribution"',
    title: "Draft Documents",
    description: "Find draft Word documents not meant for distribution",
    category: "file-discovery",
    tags: ["word", "draft", "document", "internal"],
    popularity: 75,
    dateAdded: "2019-09-05"
  },
  {
    id: "cat-33",
    query: 'filetype:csv "email" "phone"',
    title: "Contact Lists (CSV)",
    description: "Locate CSV files containing contact information",
    category: "file-discovery",
    tags: ["csv", "contacts", "email", "data"],
    popularity: 84,
    dateAdded: "2020-11-12"
  },

  // OSINT
  {
    id: "cat-34",
    query: 'site:linkedin.com "CEO" "email"',
    title: "LinkedIn CEO Profiles",
    description: "Find CEO profiles with contact information on LinkedIn",
    category: "osint",
    tags: ["linkedin", "ceo", "executive", "contact"],
    popularity: 87,
    dateAdded: "2020-03-15"
  },
  {
    id: "cat-35",
    query: 'site:pastebin.com "password" "gmail.com"',
    title: "Pastebin Credential Leaks",
    description: "Search Pastebin for leaked Gmail credentials",
    category: "osint",
    tags: ["pastebin", "leak", "credentials", "gmail"],
    popularity: 94,
    dateAdded: "2019-07-22",
    source: "GHDB"
  },
  {
    id: "cat-36",
    query: 'site:github.com "api_key" OR "apikey" filetype:json',
    title: "GitHub API Keys",
    description: "Find exposed API keys in GitHub JSON files",
    category: "osint",
    tags: ["github", "api-key", "leak", "json"],
    popularity: 96,
    dateAdded: "2021-01-08",
    source: "GHDB"
  },
  {
    id: "cat-37",
    query: 'site:trello.com "password" OR "credentials"',
    title: "Trello Board Leaks",
    description: "Discover public Trello boards with sensitive information",
    category: "osint",
    tags: ["trello", "leak", "password", "public"],
    popularity: 85,
    dateAdded: "2020-09-18"
  },
  {
    id: "cat-38",
    query: 'site:docs.google.com "confidential" OR "internal"',
    title: "Public Google Docs",
    description: "Find publicly accessible confidential Google documents",
    category: "osint",
    tags: ["google-docs", "public", "confidential", "leak"],
    popularity: 88,
    dateAdded: "2020-04-28"
  },

  // Vulnerabilities
  {
    id: "cat-39",
    query: 'inurl:".php?id=" site:*.edu',
    title: "SQL Injection Candidates (EDU)",
    description: "Find potential SQL injection points on educational sites",
    category: "vulnerabilities",
    tags: ["sqli", "injection", "php", "edu"],
    popularity: 90,
    dateAdded: "2019-06-10",
    source: "GHDB"
  },
  {
    id: "cat-40",
    query: 'inurl:"file=" ext:php',
    title: "LFI Candidates",
    description: "Locate potential Local File Inclusion vulnerabilities",
    category: "vulnerabilities",
    tags: ["lfi", "inclusion", "php", "vulnerability"],
    popularity: 89,
    dateAdded: "2020-02-05"
  },
  {
    id: "cat-41",
    query: 'inurl:"page=" OR inurl:"url=" ext:php',
    title: "RFI/SSRF Candidates",
    description: "Find potential Remote File Inclusion or SSRF points",
    category: "vulnerabilities",
    tags: ["rfi", "ssrf", "php", "vulnerability"],
    popularity: 87,
    dateAdded: "2020-07-14"
  },
  {
    id: "cat-42",
    query: 'inurl:"/wp-content/plugins/" "readme.txt"',
    title: "WordPress Plugin Info",
    description: "Discover WordPress plugin readme files for version enumeration",
    category: "vulnerabilities",
    tags: ["wordpress", "plugin", "version", "enumeration"],
    popularity: 83,
    dateAdded: "2019-12-20"
  },
  {
    id: "cat-43",
    query: '"Powered by" "v1." OR "v2." inurl:"/admin"',
    title: "Outdated Admin Panels",
    description: "Find potentially outdated admin panels by version numbers",
    category: "vulnerabilities",
    tags: ["version", "outdated", "admin", "enumeration"],
    popularity: 76,
    dateAdded: "2020-10-08"
  },

  // Additional Popular Dorks
  {
    id: "cat-44",
    query: 'site:*.s3.amazonaws.com filetype:pdf',
    title: "AWS S3 PDF Files",
    description: "Find PDF files stored on public AWS S3 buckets",
    category: "file-discovery",
    tags: ["aws", "s3", "cloud", "pdf"],
    popularity: 91,
    dateAdded: "2021-03-05",
    source: "GHDB"
  },
  {
    id: "cat-45",
    query: 'site:drive.google.com "password"',
    title: "Google Drive Password Files",
    description: "Search Google Drive for publicly shared password files",
    category: "osint",
    tags: ["google-drive", "password", "leak", "cloud"],
    popularity: 88,
    dateAdded: "2020-08-25"
  },
  {
    id: "cat-46",
    query: 'intitle:"Apache2 Ubuntu Default Page"',
    title: "Default Apache Pages",
    description: "Find servers with default Apache installation pages",
    category: "servers",
    tags: ["apache", "default", "ubuntu", "misconfiguration"],
    popularity: 82,
    dateAdded: "2019-10-30"
  },
  {
    id: "cat-47",
    query: 'intitle:"Welcome to nginx!"',
    title: "Default Nginx Pages",
    description: "Locate servers with default Nginx welcome pages",
    category: "servers",
    tags: ["nginx", "default", "server", "misconfiguration"],
    popularity: 80,
    dateAdded: "2020-01-18"
  },
  {
    id: "cat-48",
    query: '"phpinfo()" filetype:php',
    title: "PHP Info Pages",
    description: "Find exposed PHP info pages revealing server configuration",
    category: "servers",
    tags: ["php", "phpinfo", "config", "server"],
    popularity: 93,
    dateAdded: "2019-04-12",
    source: "GHDB"
  },
  {
    id: "cat-49",
    query: 'inurl:"/server-status" "Apache Server Status"',
    title: "Apache Server Status",
    description: "Discover exposed Apache server status pages",
    category: "servers",
    tags: ["apache", "status", "monitoring", "exposed"],
    popularity: 85,
    dateAdded: "2020-05-07"
  },
  {
    id: "cat-50",
    query: 'site:exploit-db.com "Google Dork"',
    title: "ExploitDB Dorks",
    description: "Find Google Dorks documented on ExploitDB",
    category: "osint",
    tags: ["exploitdb", "ghdb", "dorks", "security"],
    popularity: 95,
    dateAdded: "2021-02-20",
    source: "GHDB"
  }
];

export const dorkCategories = [
  { id: 'all', name: 'All Categories', icon: 'Grid' },
  { id: 'sensitive-directories', name: 'Sensitive Directories', icon: 'FolderOpen' },
  { id: 'sensitive-files', name: 'Sensitive Files', icon: 'FileWarning' },
  { id: 'login-pages', name: 'Login Pages', icon: 'LogIn' },
  { id: 'error-messages', name: 'Error Messages', icon: 'AlertTriangle' },
  { id: 'network-devices', name: 'Network Devices', icon: 'Router' },
  { id: 'databases', name: 'Databases', icon: 'Database' },
  { id: 'servers', name: 'Servers', icon: 'Server' },
  { id: 'file-discovery', name: 'File Discovery', icon: 'FileSearch' },
  { id: 'osint', name: 'OSINT', icon: 'Search' },
  { id: 'vulnerabilities', name: 'Vulnerabilities', icon: 'Shield' },
] as const;

export function searchCatalog(query: string): CatalogDork[] {
  if (!query.trim()) return [];
  
  const searchTerms = query.toLowerCase().split(/\s+/);
  
  return popularDorks
    .filter(dork => {
      const searchableText = `${dork.title} ${dork.description} ${dork.query} ${dork.tags.join(' ')}`.toLowerCase();
      return searchTerms.every(term => searchableText.includes(term));
    })
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, 10);
}

export function getTopDorks(limit: number = 20): CatalogDork[] {
  return [...popularDorks]
    .sort((a, b) => b.popularity - a.popularity)
    .slice(0, limit);
}

export function getDorksByCategory(category: string): CatalogDork[] {
  if (category === 'all') return popularDorks;
  return popularDorks.filter(dork => dork.category === category);
}
